import { Outlet, createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import Tablist from './-Tablist';

export const Route = createFileRoute('/_app/account/settings/_layout')({
  component: Layout
});

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className='flex flex-col flex-nowrap'>
      <Tablist />
      <div>
        <Outlet />
      </div>
      <div>{children}</div>
    </div>
  );
}
